<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.775 22.6248L1.375 4.2248L2.8 2.7998L21.2 21.1998L19.775 22.6248ZM15.825 12.9998L13.825 10.9998H18V12.9998H15.825ZM10.825 7.9998L8.825 5.9998H21V7.9998H10.825ZM10 17.9998V15.9998H14V17.9998H10ZM6 12.9998V10.9998H10.15V12.9998H6ZM3 7.9998V5.9998H5.15V7.9998H3Z"
      fill="currentColor" />
  </svg>
</template>
